import { useQuery, UseQueryOptions } from 'react-query';

import { SimilarDealReport, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useRelatedDealsQuery(
	guid: Guid | undefined,
	options?:
		| Omit<UseQueryOptions<SimilarDealReport, unknown, SimilarDealReport, any>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.RelatedDeals(guid),
		() => AxiosUtils.getResponseData<SimilarDealReport>(api.get(CerebroApiEndpoints.RelatedDeals(guid))),
		options
	);
}
